import localforage from "localforage";

export enum LocalStorageKeys {
  Tokens = "tokens",
  // Separate from `Tokens` (the company-owner session) so visiting a public
  // booking page never clobbers/is-clobbered-by an owner's admin session in
  // the same browser.
  GuestTokens = "guest_tokens",
}

export const localForageStorage = localforage.createInstance({
  driver: localforage.INDEXEDDB,
  name: "booqimate",
  version: 1,
  storeName: "booqimate",
});
